import React from "react";
import RefreshQR from "pageComponents/qr/RefreshQR";

export default function QRPage(){
    return (
        <div >
          <RefreshQR/>
        </div>
      );
}